/**
 * Shared attendance month lock helpers (locks.month is 1–12).
 */

/** @param {Array<{month?: number, year?: number}>} locks */
export function isAttendanceMonthLocked(locks, month0Based, year) {
  if (!Array.isArray(locks) || !Number.isFinite(month0Based) || !Number.isFinite(year)) {
    return false;
  }
  const m = Number(month0Based) + 1;
  const y = Number(year);
  return locks.some((lock) => Number(lock?.month) === m && Number(lock?.year) === y);
}

/** @param {string} ymd YYYY-MM-DD */
export function isAttendanceDateLocked(locks, ymd) {
  const key = String(ymd || "").slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(key)) return false;
  const [y, m] = key.split("-").map(Number);
  return isAttendanceMonthLocked(locks, m - 1, y);
}

/** Returns first locked YMD from the list, or null. */
export function findLockedAttendanceDate(locks, ymds = []) {
  for (const ymd of ymds) {
    const key = String(ymd || "").slice(0, 10);
    if (isAttendanceDateLocked(locks, key)) return key;
  }
  return null;
}
